import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useState } from "react";
import { Button, Input } from "src/components";
import { checkPoStatus, recallInvoice } from "src/services/invoice-api";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { useEventStatus } from "src/hooks/useEventStatus";
import { getCookieValue } from "src/constants/functions";

const RecallInvoice = ({ onCloseModal, onSuccess }: { onCloseModal: () => void; onSuccess: () => void }) => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { invoiceApprovalData } = useSelector((state: RootState) => state.invoice);
  const [remarks, setRemarks] = useState<string>("");
  const { withEventCheck } = useEventStatus();

  const checkIfPo = async () => {
    try {
      const token: any = await getCookieValue("idToken");
      const payload = {
        "invoice_seqId": invoiceApprovalData?.invoice?.uid,
        "company_code": invoiceApprovalData?.company_code
      }
      const response = await checkPoStatus(payload, token);
      if (response?.data?.success == "success") {
        return true
      } else {
        toast({ description: response?.data?.message, variant: "destructive" });
        return false
      }
    } catch (error) {
      console.log(error)
      return false
    }
  }

  const handleSaveChanges = async () => {
    setIsLoading(true);
    try {
      const checkPoStatusDetails = await checkIfPo();
      // M10-11544
      const isAllPOGenerated = invoiceApprovalData?.invoice?.invoiceProducts?.some((item: any) =>
        item.orderProductMappings?.some((m: any) => m.is_po_generated === true)
      );
      if (isAllPOGenerated) {
        toast({ description: "PO is Already Generated ", variant: "destructive" });
        return
      }
      // M10-11544
      if (checkPoStatusDetails) {
        const payload = {
          data: {
            invoice_id: invoiceApprovalData?.invoice?.invoice_id,
            Actor_type: "Medvol",
            Invoice_Ucode: invoiceApprovalData?.invoice?.uid,
            reason: remarks
          },
          primary_key: invoiceApprovalData?.invoice?.invoice_id,
          event_type: "INVOICE_RECALL",
        };

        const response = await recallInvoice(payload, invoiceApprovalData?.company_code);

        await withEventCheck(
          () => {
            onSuccess();
          },
          response?.data?.data?.eventStreamCreated?.streamId,
          invoiceApprovalData?.company_code //M10-12758
        );

        if (response?.status !== 200) {
          throw new Error(response?.data?.message);
        }

        toast({ description: "Invoice recalled successfully", variant: "default" });
        onSuccess();
      } else {
        toast({ description: "PO status check failed", variant: "destructive" });
      }
    } catch (error: any) {
      toast({ description: error?.response?.data?.message ?? "Something went wrong", variant: "destructive" });
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  return (
    <div className="flex flex-col gap-y-2 mb-4 w-[340px] max-h-[318px] mx-auto px-6 bg-white p-4 rounded-xl">
      <div className="flex justify-between items-center">
        <p className="text-lg font-semibold text-gray-800">Remove Invoice</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
        </Button>
      </div>

      <p className="text-sm text-gray-600 mt-4">
        Are you sure you want to remove this invoice? This action will send it back to the entry screen, and any unsaved changes will be lost.
      </p>

      <Input
        placeholder="Enter remarks"
        value={remarks}
        onChange={(e: any) => setRemarks(e.target.value)}
      />
      <div className="flex justify-end gap-2 mt-4">
        <Button className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg" onClick={onCloseModal}>
          Cancel
        </Button>
        <Button
          loaderSize="small"
          isLoading={isLoading}
          className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
          onClick={handleSaveChanges}
        >
          Remove Changes
        </Button>
      </div>
    </div>
  );
};

export default RecallInvoice;
